<template>
  <span class="ml-1 text-main-red">*</span>
</template>
